/* Custom store features: sticky add-to-cart, add-on upsells,
   delivery date estimates, review slider dots, cart reservation timer. */
(() => {
  // ---------- Add-on upsells & bundles: add checked extras after main item ----------
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    const extras = [...document.querySelectorAll(`[data-dv-addon-for="${form.id}"]:checked`)]
      .map((el) => ({ id: Number(el.value), quantity: 1 }));
    if (!extras.length) return;
    fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: extras }),
    }).catch(() => {});
  }, true);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-dv-add-items]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    const root = btn.closest('[data-dv-bundle]');
    const ids = root ? [...root.querySelectorAll('[data-dv-bundle-variant]')].map((el) => Number(el.value)) : btn.dataset.dvAddItems.split(',').map(Number);
    await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.filter(Boolean).map((id) => ({ id, quantity: 1 })) }),
    });
    window.location.href = window.routes?.cart_url || '/cart';
  });

  // ---------- Delivery date estimates ----------
  const fmtDate = (d, el) => {
    const months = (el.dataset.months || '').split(',').map((s) => s.trim());
    const days = (el.dataset.days || '').split(',').map((s) => s.trim());
    const wd = days[(d.getDay() + 6) % 7] || '';
    const m = months[d.getMonth()] || d.getMonth() + 1;
    return el.dataset.format === 'dd_mm' ? `${wd}, ${d.getDate()} ${m}` : `${wd}, ${m} ${d.getDate()}`;
  };
  const renderDates = () => document.querySelectorAll('[data-dv-date]').forEach((el) => {
    const add = (n) => { const d = new Date(); d.setDate(d.getDate() + Number(n)); return fmtDate(d, el.closest('[data-months]')); };
    el.innerHTML = el.dataset.dvDate.replace('[start_date]', add(el.dataset.min)).replace('[end_date]', add(el.dataset.max));
  });

  // ---------- Review slider dots ----------
  const initReviews = () => document.querySelectorAll('.dv-reviews').forEach((track) => {
    const dots = track.nextElementSibling;
    if (!dots || dots.dataset.ready) return;
    dots.dataset.ready = '1';
    [...track.children].forEach((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', `${i + 1}`);
      b.addEventListener('click', () => track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }));
      dots.appendChild(b);
    });
    const update = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      [...dots.children].forEach((d, j) => d.setAttribute('aria-current', i === j));
    };
    track.addEventListener('scroll', update, { passive: true }); update();
  });

  // ---------- Cart reservation timer ----------
  const initTimer = () => document.querySelectorAll('[data-dv-timer]').forEach((el) => {
    if (el._dvT) return;
    const key = 'dvCartTimerEnd';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end < Date.now()) { end = Date.now() + Number(el.dataset.dvTimer) * 60000; sessionStorage.setItem(key, end); }
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const m = String(Math.floor(left / 60000)).padStart(2, '0');
      const s = String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
      el.querySelectorAll('.dv-timer-value').forEach((v) => (v.textContent = `${m}:${s}`));
    };
    tick(); el._dvT = setInterval(tick, 1000);
  });

  const init = () => { renderDates(); initReviews(); initTimer(); };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(() => initTimer()).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- Sticky add to cart ----------
  if (!customElements.get('dv-sticky-atc')) {
    customElements.define('dv-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this._dvInit) return;
        if (this.parentElement !== document.body) { this._dvMoving = true; document.body.appendChild(this); return; }
        this._dvInit = true;
        document.querySelectorAll(`body > dv-sticky-atc[data-form="${this.dataset.form}"]`).forEach((el) => el !== this && el.remove());
        const target = document.getElementById(this.dataset.form);
        const anchor = target?.querySelector('[type=submit]') || target;
        if (!anchor) return;
        const setVisible = (v) => {
          this.classList.toggle('is-visible', v);
          document.body.classList.toggle('dv-sticky-active', v);
          document.body.style.setProperty('--dv-sticky-h', `${this.offsetHeight + 8}px`);
        };
        if (this.dataset.when === 'always') setVisible(true);
        else new IntersectionObserver(([en]) => setVisible(!en.isIntersecting && en.boundingClientRect.top < 0)).observe(anchor);
        const select = this.querySelector('select');
        select?.addEventListener('change', () => {
          const idInput = target.querySelector('input[name=id]');
          if (idInput) idInput.value = select.value;
          const opt = select.selectedOptions[0];
          this.querySelector('.dv-sticky__price').innerHTML = opt.dataset.price;
          this.querySelector('.dv-sticky__compare')?.remove();
        });
        this.querySelector('button')?.addEventListener('click', () => {
          if (select) { const idInput = target.querySelector('input[name=id]'); if (idInput) idInput.value = select.value; }
          const btn = target.querySelector('[type=submit]');
          btn ? btn.click() : target.requestSubmit();
        });
      }
    });
  }
})();
